import { useSelector } from '../actions/types';
import * as selectors from '../selectors';
export default function useSearchPageData() {
    const searchTerm = useSelector(selectors.searchTerm);
    const fetchingStatus = useSelector(state => selectors.searchPageFetchingStatus(state, searchTerm || ''));
    return {
        fetchingStatus,
        searchTerm,
    };
}
//# sourceMappingURL=useSearchPageData.js.map